import { CrmAppConfiguration } from '@touch4it/ng-swp/core/types';

import { environment } from '../../environments/environment';

export const crmConfig: CrmAppConfiguration = {
  environment,
};
